<template>
  <div>
    <div class="row sits-sign-up">
      <div class="col-lg-12 col-md-12 col-12">
        <h3 class="mb-3">Welcome</h3>
        <p>
          Thank you for your request to become a partner of the Vehicle
          Solutions.
        </p>
        <p>A member of our friendly team will contact you shortly.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SignUpWelcomeMsg'
}
</script>
